import { useWatch } from 'react-hook-form';
import { useCampaignContext } from '../../../context';
import { getIsSendTimeWithinQuietHours } from '../ScheduleCampaignModal.utils';

export const useSendTimeIsWithinQuietHours = () => {
  const [sendTime, startDate] = useWatch({ name: ['startTime', 'startDate'] });

  const { campaign } = useCampaignContext();
  const { customQuietHours } = campaign;

  const sendSkip = !!customQuietHours?.sendSkip;

  const isSendTimeWithinQuietHours = getIsSendTimeWithinQuietHours(
    sendTime,
    startDate,
    customQuietHours,
  );

  return {
    isSendTimeWithinQuietHours,
    isSendTimeWithinQuietHoursAndSkipped: isSendTimeWithinQuietHours && sendSkip,
    isSendTimeWithinQuietHoursAndNotSkipped: isSendTimeWithinQuietHours && !sendSkip,
  };
};
